import React, { useEffect, useState } from 'react';
import cookie from 'react-cookies';

export default (name, id, vars) => {
	let [variation, setVariation] = useState(false);

	useEffect(() => {
		const cookieName = `go_exp_${id}`;
		var url = new URL(window.location.href);
		var urlId = url.searchParams.get(id) || url.searchParams.get(name);
		if (urlId) {
			console.log('=== dev exp: ', id, urlId);
			const variation = Number(urlId) || 0;
			cookie.save(cookieName, variation, { path: '/' });
			setVariation(variation);
		} else {
			if (typeof cookie.load(cookieName) !== 'undefined') {
				setVariation(Number(cookie.load(cookieName)));
			} else {
				var randomIndex =
					typeof window.google_optimize !== 'undefined'
						? Number(window.google_optimize.get(id))
						: Math.floor(Math.random() * vars.length);
				cookie.save(cookieName, randomIndex, { path: '/' });
				setVariation(randomIndex);
			}
		}
		window._exps = window._exps || {};
		window._exps[name] = Number(cookie.load(cookieName));
		if (window._exps[name] !== 0) {
			window.__insp && window.__insp.push(['tagSession', `exp_${name}`]);
		}

		if (!urlId) {
			let GOLogIteration = 0;
			let GOLogInterval = GOLogInterval || {};
			GOLogInterval[id] = setInterval(function() {
				if (typeof window.ga !== 'undefined' && typeof window.google_optimize != 'undefined') {
					clearInterval(GOLogInterval[id]);
					window.ga('set', 'exp', `${id}.${cookie.load(cookieName)}`);
					// console.log(`--- EXP ${id}:${cookie.load(cookieName)} (${name}, go:${window.google_optimize.get(id)})`);
					let realVariation = Number(window.google_optimize.get(id)) || 0;
					if (!urlId) {
						setVariation(realVariation);
					}
					window._exps[name] = realVariation;
					cookie.save(cookieName, realVariation, { path: '/' });
					document.getElementById('hideAll').style = '';
					clearTimeout(window.logExps);
					window.logExps = window.setTimeout(() => {
						console.log(window._exps);
					}, 1000);
				} else {
					GOLogIteration++;
				}
				if (GOLogIteration > 10) {
					clearInterval(GOLogInterval[id]);
					console.log(`--- EXP ${id} (${name}) timeout`);
					document.getElementById('hideAll').style = '';
					clearTimeout(window.logExps);
					window.logExps = window.setTimeout(() => {
						console.log(window._exps);
					}, 1000);
				}
			}, 200);
		}
	}, []);

	if (variation === false) {
		return (
			<>
				<div dangerouslySetInnerHTML={{ __html: `<!-- EXP:${id} -->` }} />
			</>
		);
	} else {
		return <>{vars[variation]}</>;
	}
};
